<app-date-scroller-input
    [formField]="dateForm.date"
    [period]="TimePeriodEnum.Day"
    (dateRangeChange)="period.set($event)"
></app-date-scroller-input>

<div class="chart-content">
    @if (loading()) {
        <app-loading></app-loading>
    } @else if (chartItems().length) {
        <p-chart type="bar" [data]="chartData()" [options]="chartOptions"></p-chart>
        <app-dashboard-chart-tooltip [data]="chartTooltip()"></app-dashboard-chart-tooltip>
    } @else {
        <app-empty-state></app-empty-state>
    }
</div>
